'use client';

import { useCustomerly } from 'react-live-chat-customerly';
import { useEffect } from 'react';

/**
 * L'arancione del marchio, quello del logo e di `--color-accent-500`.
 *
 * Scritto per esteso e non preso dal token perché Customerly è un SDK di
 * terze parti: vuole una stringa esadecimale, non una variabile CSS. Se
 * l'arancione del sito cambia, va cambiato anche qui.
 */
const BRAND_ACCENT = '#ea580c';

const CustomerlyLoader = () => {
  const { load } = useCustomerly();

  useEffect(() => {
    load({
      // Arancione come le CTA principali, che sul sito sono `bg-accent
      // text-white`: la bolla è una chiamata all'azione, non un elemento di
      // struttura, e il navy la faceva sparire nel piè di pagina.
      accentColor: BRAND_ACCENT,
      contrastColor: '#FFFFFF',
      // A sinistra copriva l'inizio dei contenuti (e in basso a destra l'occhio
      // ormai si aspetta la chat)
      direction: 'right',
    });
  }, [load]);

  return <></>;
};

export default CustomerlyLoader;
